var _g, _rect, _rect2, _line, _g2, _rect3, _g3, _circle, _g4, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 126,
    viewBox: "0 0 86 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_468_8786)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 91.7395,
    width: 8.55249,
    height: 20.431,
    rx: 4.27625,
    fill: "#F7D62A"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.950277,
    y: 92.6898,
    width: 6.65194,
    height: 18.5304,
    rx: 3.32597,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3975,
    y: 92.6898,
    width: 6.65194,
    height: 18.5304,
    rx: 3.32597,
    fill: "#F7D62A",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 43.2374,
    y1: 59.4302,
    x2: 43.2374,
    y2: 76.06,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_468_8786)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.7842,
    y: 67.9827,
    width: 20.9061,
    height: 12.3536,
    rx: 6.1768,
    fill: "#F7D62A"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7345,
    y: 68.9329,
    width: 19.0055,
    height: 10.453,
    rx: 5.22652,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_468_8786)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.238,
    cy: 53.2533,
    r: 7.60221,
    fill: "#F7D62A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.238,
    cy: 53.2533,
    r: 6.65194,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_468_8786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27637 100.767C4.27637 86.3345 15.9763 74.6345 30.409 74.6345H55.5913C70.0239 74.6345 81.7239 86.3345 81.7239 100.767V113.121C81.7239 120.206 75.9803 125.949 68.8952 125.949H17.1051C10.02 125.949 4.27637 120.206 4.27637 113.121V100.767Z",
    fill: "#F7D62A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22664 100.767C5.22664 86.8593 16.5012 75.5848 30.409 75.5848H55.5913C69.4991 75.5848 80.7737 86.8593 80.7737 100.767V113.121C80.7737 119.681 75.4555 124.999 68.8952 124.999H17.1051C10.5448 124.999 5.22664 119.681 5.22664 113.121V100.767Z",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6083,
    cy: 92.6899,
    r: 9.50277,
    fill: "white",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6084,
    cy: 92.6899,
    r: 5.22652,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7082,
    cy: 91.7397,
    r: 1.90055,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9179,
    cy: 92.6899,
    r: 9.50277,
    fill: "white",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9179,
    cy: 92.6899,
    r: 5.22652,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.0177,
    cy: 91.7397,
    r: 1.90055,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7344 109.32C37.5355 116.684 48.2261 116.684 52.2648 109.32",
    stroke: "#BAA11D",
    strokeWidth: 1.90055,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7037 50.6507L50.095 51.5164L49.7037 50.6507ZM43.7111 53.3593L44.1023 54.225L43.7111 53.3593ZM42.6885 53.3593L42.2972 54.225H42.2972L42.6885 53.3593ZM36.6958 50.6507L36.3045 51.5164L36.6958 50.6507ZM49.7848 40.1923L49.171 40.9173L49.7848 40.1923ZM40.7986 42.3752C40.274 42.3752 39.8486 42.8006 39.8486 43.3252C39.8486 43.8499 40.274 44.2752 40.7986 44.2752V42.3752ZM39.0275 46.4901C39.5522 46.4901 39.9775 46.0647 39.9775 45.5401C39.9775 45.0154 39.5522 44.5901 39.0275 44.5901V46.4901ZM43.3077 46.8029C42.783 46.8029 42.3577 47.2283 42.3577 47.7529C42.3577 48.2776 42.783 48.7029 43.3077 48.7029V46.8029ZM44.0651 13.4073C44.5898 13.4073 45.0151 12.9819 45.0151 12.4573C45.0151 11.9326 44.5898 11.5073 44.0651 11.5073V13.4073ZM43.2713 39.0746C43.2713 39.5993 43.6967 40.0246 44.2213 40.0246C44.746 40.0246 45.1713 39.5993 45.1713 39.0746H43.2713ZM44.2213 27.277L44.2166 26.327L44.2213 27.277ZM44.2213 24.1889L44.2166 25.1389L44.2213 24.1889ZM44.2213 21.4112L44.228 22.3612L44.2213 21.4112ZM44.2213 33.143H45.1713C45.1713 32.6183 44.746 32.193 44.2213 32.193V33.143ZM28.9393 16.2105C28.9393 8.33466 35.3239 1.95 43.1998 1.95V0.05C34.2746 0.05 27.0393 7.28532 27.0393 16.2105H28.9393ZM43.1998 1.95C51.0757 1.95 57.4603 8.33466 57.4603 16.2105H59.3603C59.3603 7.28532 52.125 0.05 43.1998 0.05V1.95ZM34.4433 30.0723C34.4433 27.2098 32.8763 24.9159 31.5387 22.8498C30.1505 20.7054 28.9393 18.7247 28.9393 16.2105H27.0393C27.0393 19.3556 28.58 21.7757 29.9438 23.8823C31.3583 26.0673 32.5433 27.8746 32.5433 30.0723H34.4433ZM57.4603 16.2105C57.4603 18.7282 56.2454 20.7563 54.8583 22.9217C53.5274 24.9995 51.9562 27.2993 51.9562 30.0723H53.8562C53.8562 27.9665 55.0372 26.165 56.4582 23.9465C57.8232 21.8155 59.3603 19.3521 59.3603 16.2105H57.4603ZM49.3125 49.785L43.3198 52.4936L44.1023 54.225L50.095 51.5164L49.3125 49.785ZM43.0798 52.4936L37.0871 49.785L36.3045 51.5164L42.2972 54.225L43.0798 52.4936ZM43.3198 52.4936C43.2397 52.5298 43.1598 52.5298 43.0798 52.4936L42.2972 54.225C42.8747 54.486 43.5248 54.486 44.1023 54.225L43.3198 52.4936ZM34.8506 49.1329C34.8506 50.1149 35.371 51.0944 36.3045 51.5164L37.0871 49.785C36.9409 49.7189 36.7506 49.4934 36.7506 49.1329H34.8506ZM49.649 49.1329C49.649 49.4934 49.4586 49.7189 49.3125 49.785L50.095 51.5164C51.0285 51.0944 51.549 50.1149 51.549 49.1329H49.649ZM48.3006 38.6988H38.099V40.5989H48.3006V38.6988ZM48.3006 40.5989C48.6333 40.5989 48.9357 40.7181 49.171 40.9173L50.3987 39.4672C49.8331 38.9884 49.0994 38.6988 48.3006 38.6988V40.5989ZM49.171 40.9173C49.4649 41.1662 49.649 41.5347 49.649 41.9473H51.549C51.549 40.9526 51.1008 40.0616 50.3987 39.4672L49.171 40.9173ZM51.9562 30.0723C51.9562 34.8759 50.7424 37.8132 49.0976 39.5363L50.472 40.8482C52.565 38.6556 53.8562 35.1761 53.8562 30.0723H51.9562ZM36.7506 41.9473C36.7506 41.5348 36.9346 41.1663 37.2284 40.9175L36.0005 39.4675C35.2986 40.0619 34.8506 40.9528 34.8506 41.9473H36.7506ZM37.2284 40.9175C37.4638 40.7182 37.7662 40.5989 38.099 40.5989V38.6988C37.3 38.6988 36.5661 38.9885 36.0005 39.4675L37.2284 40.9175ZM37.3017 39.5366C35.6571 37.8135 34.4433 34.8762 34.4433 30.0723H32.5433C32.5433 35.1763 33.8345 38.6558 35.9273 40.8484L37.3017 39.5366ZM49.649 41.9473V43.3252H51.549V41.9473H49.649ZM50.599 42.3752H40.7986V44.2752H50.599V42.3752ZM36.7506 49.1329V45.5401H34.8506V49.1329H36.7506ZM36.7506 45.5401V41.9473H34.8506V45.5401H36.7506ZM35.8006 46.4901H39.0275V44.5901H35.8006V46.4901ZM49.649 43.3252V47.7529H51.549V43.3252H49.649ZM49.649 47.7529V49.1329H51.549V47.7529H49.649ZM50.599 46.8029H43.3077V48.7029H50.599V46.8029ZM37.9337 16.9345C37.9337 16.1386 38.446 15.2794 39.5655 14.5716C40.6729 13.8714 42.2612 13.4073 44.0651 13.4073V11.5073C41.958 11.5073 40.0056 12.0454 38.5501 12.9656C37.1066 13.8783 36.0337 15.2577 36.0337 16.9345H37.9337ZM44.0651 32.193C42.2612 32.193 40.6729 31.7288 39.5655 31.0287C38.446 30.3209 37.9337 29.4617 37.9337 28.6657H36.0337C36.0337 30.3425 37.1066 31.7219 38.5501 32.6346C40.0056 33.5549 41.958 34.093 44.0651 34.093V32.193ZM44.0651 19.2729C45.1032 19.2729 46.3645 19.3502 47.3403 19.5619C47.8364 19.6695 48.1859 19.7969 48.3885 19.9195C48.5979 20.0462 48.4658 20.0432 48.4658 19.8673H50.3658C50.3658 19.0759 49.832 18.5722 49.372 18.2939C48.9052 18.0115 48.3177 17.8297 47.7431 17.7051C46.5777 17.4523 45.1637 17.3729 44.0651 17.3729V19.2729ZM37.9337 22.8001C37.9337 22.0762 38.3534 21.3058 39.2738 20.6351L38.1549 19.0995C36.919 20.0001 36.0337 21.2805 36.0337 22.8001H37.9337ZM39.2738 20.6351C40.3807 19.8285 42.0904 19.2729 44.0651 19.2729V17.3729C41.7664 17.3729 39.6447 18.0139 38.1549 19.0995L39.2738 20.6351ZM44.0651 20.4618C42.0904 20.4618 40.3807 19.9061 39.2738 19.0995L38.1549 20.6351C39.6447 21.7207 41.7664 22.3618 44.0651 22.3618V20.4618ZM39.2738 19.0995C38.3534 18.4288 37.9337 17.6584 37.9337 16.9345H36.0337C36.0337 18.4542 36.919 19.7346 38.1549 20.6351L39.2738 19.0995ZM37.9337 28.6657C37.9337 27.9419 38.3534 27.1714 39.2738 26.5007L38.1549 24.9651C36.919 25.8657 36.0337 27.1461 36.0337 28.6657H37.9337ZM39.2738 26.5007C40.3807 25.6941 42.0904 25.1385 44.0651 25.1385V23.2385C41.7664 23.2385 39.6447 23.8795 38.1549 24.9652L39.2738 26.5007ZM44.0651 26.3274C42.0904 26.3274 40.3807 25.7718 39.2738 24.9651L38.1549 26.5007C39.6447 27.5863 41.7664 28.2274 44.0651 28.2274V26.3274ZM39.2738 24.9652C38.3534 24.2944 37.9337 23.524 37.9337 22.8001H36.0337C36.0337 24.3198 36.919 25.6002 38.1549 26.5007L39.2738 24.9652ZM48.4658 25.7329C48.4658 25.6137 48.559 25.6139 48.3924 25.7205C48.2126 25.8355 47.8921 25.9575 47.4186 26.0596C46.4864 26.2604 45.2683 26.3218 44.2166 26.327L44.226 28.227C45.3078 28.2216 46.687 28.1607 47.8187 27.917C48.3771 27.7967 48.9552 27.6159 49.416 27.3212C49.89 27.0181 50.3658 26.5018 50.3658 25.7329H48.4658ZM44.2166 26.327C44.1656 26.3273 44.1151 26.3274 44.0651 26.3274V28.2274C44.1181 28.2274 44.1717 28.2273 44.226 28.227L44.2166 26.327ZM44.0651 25.1385C44.1151 25.1385 44.1656 25.1386 44.2166 25.1389L44.226 23.2389C44.1717 23.2386 44.1181 23.2385 44.0651 23.2385V25.1385ZM44.2166 25.1389C45.2683 25.144 46.4864 25.2055 47.4186 25.4063C47.8921 25.5083 48.2126 25.6304 48.3924 25.7453C48.559 25.8519 48.4658 25.8521 48.4658 25.7329H50.3658C50.3658 24.9641 49.89 24.4478 49.416 24.1447C48.9552 23.85 48.3771 23.6692 47.8187 23.5489C46.687 23.3051 45.3078 23.2442 44.226 23.2389L44.2166 25.1389ZM48.4658 19.8673C48.4658 19.6964 48.5921 19.6882 48.4013 19.8073C48.2134 19.9245 47.8842 20.0498 47.4086 20.1576C46.473 20.3697 45.2521 20.4539 44.2146 20.4612L44.228 22.3612C45.324 22.3534 46.7003 22.2664 47.8287 22.0106C48.385 21.8845 48.9544 21.7017 49.4071 21.4192C49.8569 21.1385 50.3658 20.6389 50.3658 19.8673H48.4658ZM44.2146 20.4612C44.1642 20.4616 44.1143 20.4618 44.0651 20.4618V22.3618C44.1188 22.3618 44.1731 22.3616 44.228 22.3612L44.2146 20.4612ZM45.1713 39.0746V33.143H43.2713V39.0746H45.1713ZM44.0651 34.093H44.2213V32.193H44.0651V34.093Z",
    fill: "#BAA11D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_468_8786",
    x: 0,
    y: 91.7395,
    width: 8.55273,
    height: 20.4309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_468_8786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_468_8786",
    x: 32.7842,
    y: 67.9827,
    width: 20.9062,
    height: 12.3535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_468_8786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_468_8786",
    x: 35.6357,
    y: 45.6511,
    width: 15.2041,
    height: 15.2043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_468_8786"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_468_8786",
    x: 4.27637,
    y: 74.6345,
    width: 77.4473,
    height: 51.3149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_468_8786"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyIcon);
export default __webpack_public_path__ + "static/media/studyIcon.bddc573588c8fc1dbc8f588d2ee8b0b4.svg";
export { ForwardRef as ReactComponent };